import  { apiRequest } from '../../apiCall'

export const getSettingsRequest = () => apiRequest('WebsiteDomain.GetQueueStrategy')
export const updateSettingsRequest = (params) => apiRequest('WebsiteDomain.UpdateQueueStrategy',{...params})
